import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { api } from "../lib/api";
import { tail } from "../lib/format";

interface N {
  depth?: number;
  class?: string;
  viewId?: string | null;
  contentDesc?: string | null;
  text?: string | null;
  bounds?: number[] | string;
  clickable?: boolean;
  editable?: boolean;
  scrollable?: boolean;
  visible?: boolean;
  addressing?: string;
  anchor?: string;
}

export function NodeTree({ sha }: { sha: string }) {
  const q = useQuery({ queryKey: ["blob", sha], queryFn: () => api.blobJson<N[] | { nodes: N[] }>(sha) });
  const [visibleOnly, setVisibleOnly] = useState(true);
  if (q.isLoading) return <div className="muted">loading tree…</div>;
  if (q.error) return <div className="muted">tree unavailable: {(q.error as Error).message}</div>;
  const raw = q.data;
  const nodes: N[] = Array.isArray(raw) ? raw : (raw as any)?.nodes ?? [];
  const shown = visibleOnly ? nodes.filter((n) => n.visible !== false) : nodes;
  return (
    <div>
      <div className="row" style={{ marginBottom: 6 }}>
        <label className="muted" style={{ fontSize: 12 }}>
          <input type="checkbox" checked={visibleOnly} onChange={(e) => setVisibleOnly(e.target.checked)} /> visible only
        </label>
        <span className="muted" style={{ fontSize: 12 }}>
          {shown.length}/{nodes.length} nodes
        </span>
      </div>
      <div className="tree" style={{ maxHeight: 420, overflow: "auto" }}>
        {shown.map((n, i) => (
          <div key={i} className={`node ${n.visible === false ? "hidden" : ""}`} style={{ paddingLeft: (n.depth ?? 0) * 12 }}>
            <span className="cls">{(n.class ?? "?").split(".").pop()}</span>{" "}
            {n.viewId && <span className="id">#{tail(n.viewId)}</span>}{" "}
            {n.text && <span className="txt">{JSON.stringify(n.text)}</span>}{" "}
            {n.contentDesc && <span className="txt">({n.contentDesc})</span>}{" "}
            {n.clickable && <span className="flag">clickable</span>}{" "}
            {n.editable && <span className="flag">editable</span>}{" "}
            {n.scrollable && <span className="flag">scrollable</span>}{" "}
            {n.bounds && <span className="muted">{Array.isArray(n.bounds) ? n.bounds.join(",") : n.bounds}</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
